import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export const getDisabledCheckoutPageCalls = createSelector(
  [getSettings],
  settings => (settings.disabled_checkout_page_calls ? settings.disabled_checkout_page_calls : []),
);
